import { render, staticRenderFns } from "./IcoCompetencyVisualization.vue?vue&type=template&id=9e0ec0cc"
import script from "./IcoCompetencyVisualization.vue?vue&type=script&lang=js"
export * from "./IcoCompetencyVisualization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports